//InstantMessageChannelNewDialog
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { Dialog, IDialogButton } from "../framework/dialog";
import * as instantMessageChannelService from "../../models/services/instantMessageChannelService";
import { DialogButtonType, InstantMessageChannelArchivingType, InstantMessageChannelMessageExpirationTime, InstantMessageChannelUserActiveState, InstantMessageChannelUserType } from "ui/Scripts/source/models/enums";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { IUserListItem, UserListItem } from "../../models/user/userListItem";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelUserEditItem";
import { IUserState } from "../../models/store/storeTypes";
import { IInstantMessageChannelNew } from "ui/Scripts/source/models/instantMessage/instantMessageChannelNew";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { customHistory } from "../../framework/customHistory";
import { SaveDataObj } from "../../framework/saveData";
import { AppUtils } from "../../framework/appUtils";
import { IInstantMessageChannelAddedUser, InstantMessageChannelAddedUser } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddedUser";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { Radio } from "ui/Scripts/source/components/framework/radio";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { InstantMessageChannelHelper } from "ui/Scripts/source/models/instantMessage/instantMessageChannelHelper";
import { InstantMessageChannelUserList } from "./instantMessageChannelUserList";
import { SelectUserList } from "../framework/selectUserList";
import { SaveAttachmentBase64 } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";

/* eslint-disable no-unused-vars */
const enum NewInstantMessageChannelType {
    OneToOne = "1",
    Internal = "2",
    External = "3"
}

const enum NewInstantMessageChannelDialogPage {
    Selection = "1",
    General = "2",
    Users = "3",
    User = "4"
}
/* eslint-enable no-unused-vars */

//InstantMessageChannelNewDialog
export interface IInstantMessageChannelNewDialogProp {
    classes?: string;
    user: IUserState;
    onClose: () => void;
}

export interface IInstantMessageChannelSaveState {
    id: string;
    companyId: string;
    code: string;
    file: IFileAttachment,
    resetPicture: boolean;
    internalChannel: boolean;
    activeState: number;
    comment: string;
    messageExpirationTime: number;
    rowId: string;
}

export interface IInstantMessageChannelNewDialogState extends IInstantMessageChannelSaveState {
    item: IInstantMessageChannelNew;
    page: NewInstantMessageChannelDialogPage;
    // Selection
    channelType: NewInstantMessageChannelType;
    // General
    messageExpirationTimes: INumberTitle[];
    picture: string;
    // Users
    channelUsers: IInstantMessageChannelEditUserItem[];
    users: IUserListItem[]
}

export class InstantMessageChannelNewDialog extends React.Component<IInstantMessageChannelNewDialogProp, IInstantMessageChannelNewDialogState> {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
            page: NewInstantMessageChannelDialogPage.Selection,
            // Selection
            channelType: NewInstantMessageChannelType.OneToOne,
            // General
            messageExpirationTimes: [
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Quarter, "3 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.HalfYear, "6 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Year, "12 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.None, Translations.Unlimited)
            ],
            companyId: "",
            id: "",
            code: "",
            file: null,
            picture: "",
            resetPicture: false,
            comment: "",
            messageExpirationTime: 0,
            internalChannel: true,
            activeState: 1,
            rowId: "",
            // Users
            channelUsers: [],
            users: [],
        };
    }

    async componentDidMount(): Promise<void> {
        const item = await AppUtils.callService(() => instantMessageChannelService.getInstantMessageChannelNew(), false);
        if (!item) return;
        this.setState({
            item,
            companyId: item.companies.length > 0 ? item.companies[0].id : "",
            messageExpirationTime: item ? item.instantMessageChannel.messageExpirationTime : 0,
            internalChannel: item ? item.instantMessageChannel.internalChannel : true,
            activeState: item ? item.instantMessageChannel.activeState : 1,
        });
    }

    //instantMessageChannelService.getInstantMessageChannelNew()

    // #region Selection
    handleChangeChannelType = (checked: boolean, channelType: NewInstantMessageChannelType) => {
        if (!checked) return;
        this.setState({
            channelType,
            internalChannel: channelType !== NewInstantMessageChannelType.External,
        });
    };
    // #endregion Selection

    // #region General
    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "xts") {
            this.setState({ code: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "messageExpirationTime") {
            this.setState({ messageExpirationTime: value.toInteger() });
        }
    };

    handleSetPicture = async (file: File) => {
        if (!file) return;
        const attachment = await FileAttachment.fileToFileAttachment(file, 0);
        if (!attachment) return;
        if (!AppUtils.validateFileAttachment(attachment)) return;
        this.setState({ file: attachment, resetPicture: false, picture: attachment.thumbnail });
    };

    handleRemovePicture = () => {
        this.setState({ file: null, resetPicture: true, picture: "" });
    };

    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (state.channelType !== NewInstantMessageChannelType.OneToOne && !state.code) {
                AppUtils.showErrorMessage(Translations.NameMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    getWarningMessage = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            return resolve("");
        });
    };
    // #endregion General

    // #region Users
    handleUsersRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            channelUsers: this.state.channelUsers.filter(i => ids.indexOf(i.id) < 0)
        });
    };
    
    modifyUsers = (companyId: string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[], removeUsers: boolean) => {
        const state = this.state;
        const channelUsers = removeUsers ? [] : state.channelUsers.slice(0);
        const users = removeUsers ? [] : state.users.slice(0);
        let internalChannel = removeUsers ? true : state.internalChannel;
        if (newUsers && newUsers.length > 0) {
            for (const newUser of newUsers) {
                const addedUser = addedUsers.find(i => i.userId === newUser.id);
                if (!addedUser) continue;
                const newChannelUser = new InstantMessageChannelEditUserItem();
                newChannelUser.id = addedUser.id;
                newChannelUser.companyId = companyId;
                newChannelUser.userType = InstantMessageChannelUserType.User;
                newChannelUser.userCode = newUser.code;
                newChannelUser.firstName = newUser.name;
                newChannelUser.lastName = "";
                newChannelUser.picture = newUser.picture;
                newChannelUser.activeState = addedUser.activeState;
                channelUsers.push(newChannelUser);
                users.push(newUser);
                if (internalChannel && newChannelUser.companyId !== state.companyId) {
                    internalChannel = false;
                }
            }
        }
        this.setState({
            channelUsers,
            users,
            internalChannel
        });
    };

    handleUsersAdded = (companyId :string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[]) => {
        this.modifyUsers(companyId, newUsers, addedUsers, false);
    };

    handleUserSelect = async (users: IUserListItem[], companyId :string) => {
        if (!users || users.length < 1) return;
        this.modifyUsers(companyId, users, users.map(i => InstantMessageChannelAddedUser.createInstantMessageChannelAddedUser(Base.getGuid(), i.id, InstantMessageChannelUserActiveState.Invited)), true);
    };
    
    handleLoadUsers = async (page: number, companyId: string): Promise<IEndlessList<UserListItem>> => {
        const state = this.state;
        const ignoreUserCodes = [this.props.user.userCode].concat(state.item.existingTwoPersonChannelPartnerUserCodes);
        return await AppUtils.callService(() => instantMessageChannelService.instantMessageChannelGetSelectUserListItems(state.companyId, Base.emptyGuid, companyId, page, ignoreUserCodes));
    };
    // #endregion Users
    
    handleMoveToPreviousPage = () => {
        const state = this.state;
        const page = state.page === NewInstantMessageChannelDialogPage.Users
            ? NewInstantMessageChannelDialogPage.General
            : NewInstantMessageChannelDialogPage.Selection;
        const removeUsers = page === NewInstantMessageChannelDialogPage.Selection;
        const channelUsers = removeUsers ? [] : state.channelUsers.slice(0);
        const users = removeUsers ? [] : state.users.slice(0);
        this.setState({
            page,
            channelUsers,
            users
        });
    };

    handleMoveToNextPage = async () => {
        const state = this.state;
        if (state.page === NewInstantMessageChannelDialogPage.General) {
            if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return;
        }
        const page = state.page === NewInstantMessageChannelDialogPage.Selection
            ? (state.channelType === NewInstantMessageChannelType.OneToOne
                ? NewInstantMessageChannelDialogPage.User
                : NewInstantMessageChannelDialogPage.General)
            : NewInstantMessageChannelDialogPage.Users;
        const internalChannel = state.page === NewInstantMessageChannelDialogPage.Selection
            ? state.channelType !== NewInstantMessageChannelType.External
            : state.internalChannel;
        this.setState({
            page,
            internalChannel
        });
    };

    closeView = (id: string): void => {
        if (id) {
            customHistory.push("/instantmessage/" + id);
        }
        this.props.onClose();
    };

    static getSaveDataFromState = async (state: IInstantMessageChannelSaveState, overrideCode: string = null, userIds: string[] = null): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("companyId", state.companyId);
        result.append("id", state.id);
        result.append("rowId", state.rowId);
        result.append("code", overrideCode ?? state.code);
        result.append("comment", state.comment);
        result.append("internalChannel", state.internalChannel);
        result.append("activeState", state.activeState);
        result.append("archivingType", InstantMessageChannelArchivingType.None);
        result.append("archivingRemoveDate", null);
        result.append("messageExpirationTime", state.messageExpirationTime);
        result.append("resetPicture", state.resetPicture);
        if (state.file) {
            result.append("attachments", await SaveAttachmentBase64.fromFileAttachments([state.file]));
        }
        if (userIds) { //Used only for saving in new wizard
            result.append("userIds", userIds);
        }
        return result;
    };

    static saveInstantMessageChannel = async (state: IInstantMessageChannelSaveState, overrideCode: string, userIds: string[] = null): Promise<SaveSuccess> => {
        const saveData = await InstantMessageChannelNewDialog.getSaveDataFromState(state, overrideCode, userIds);
        return AppUtils.callService(() => instantMessageChannelService.saveInstantMessageChannelEdit(saveData.obj));
    };

    handleSave = async () => {
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return;
        const result = await InstantMessageChannelNewDialog.saveInstantMessageChannel(state, !state.code ? Translations.NewInstantMessageChannel : null, state.users.map(i => i.id));
        if (!result) return;
        this.closeView(result.id);
    };

    handleCancel = async () => {
        this.closeView("");
    };

    render() {
        const props = this.props;
        const state = this.state;
        const item = state.item;
        if (!item) {
            return null;
        }
        const hasPartners = item.companies.length > 1;
        const nextButtonMode = state.page !== NewInstantMessageChannelDialogPage.User && state.page !== NewInstantMessageChannelDialogPage.Users;
        const buttons: IDialogButton[] = [];
        if (state.page !== NewInstantMessageChannelDialogPage.Selection) {
            buttons.push({ title: Translations.Previous, buttonType: DialogButtonType.Default, onClick: this.handleMoveToPreviousPage });
        }
        buttons.push({ title: nextButtonMode ? Translations.Next : Translations.Save, buttonType: DialogButtonType.Default, onClick: nextButtonMode ? this.handleMoveToNextPage : this.handleSave });
        const dialogClasses = "instantMessageChannelNew" + (props.classes ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={state.page === NewInstantMessageChannelDialogPage.Selection
                    ? Translations.SelectInstantMessageChannelType
                    : (state.page === NewInstantMessageChannelDialogPage.General
                        ? Translations.BasicInformation
                        : (state.page === NewInstantMessageChannelDialogPage.Users
                            ? Translations.SelectInstantMessageChannelUsers
                            : Translations.SelectInstantMessageChannelUser))}
                body={
                    <div>
                        {state.page === NewInstantMessageChannelDialogPage.Selection &&
                            <div>
                                <div className="form-group mt-2">
                                    <Radio
                                        title={Translations.InstantMessageChannelOneUser}
                                        checked={state.channelType === NewInstantMessageChannelType.OneToOne}
                                        onClickBoolean={(checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.OneToOne)}
                                    />
                                    <Radio
                                        title={Translations.InstantMessageChannelGroupInternal}
                                        checked={state.channelType === NewInstantMessageChannelType.Internal}
                                        onClickBoolean={(checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.Internal)}
                                    />
                                    <Radio
                                        title={Translations.InstantMessageChannelGroupExternal}
                                        checked={state.channelType === NewInstantMessageChannelType.External}
                                        hidden={!hasPartners}
                                        onClickBoolean={(checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.External)}
                                    />
                                </div>
                            </div>
                        }
                        {state.page === NewInstantMessageChannelDialogPage.General &&
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="userIconAndCode">
                                            <div className="pictureContainer form-group">
                                                <AvatarImage
                                                    classes="large"
                                                    id={InstantMessageChannelHelper.getAvatarId(state.channelUsers, state.picture, props.user.userCode)}
                                                    name={state.code}
                                                    image={InstantMessageChannelHelper.getPicture(state.channelUsers, state.picture, props.user.userCode)}
                                                    imageClass={InstantMessageChannelHelper.getPictureClass(state.channelUsers, state.picture, props.user.userCode)}
                                                    editable={true}
                                                    tooltip={Translations.CkickToChangeThePicture}
                                                    removeTooltip={Translations.RemovePicture}
                                                    onChange={this.handleSetPicture}
                                                    onError={(message) => AppUtils.showErrorMessage(message)}
                                                    onLongPress={state.resetPicture ? null : this.handleRemovePicture}
                                                    longPressMs={appConfig.longPressMs}
                                                />
                                            </div>
                                            <div className={"codeContainer form-group required"}>
                                                <label className="control-label">{Translations.Name}</label>
                                                <input className="form-control" type="text" name="xts" title={Translations.Name} maxLength={50} value={state.code} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group required">
                                            <label className="control-label">{Translations.MessagePreservationTime}</label>
                                            <select className="form-control" name="messageExpirationTime" title={Translations.MessagePreservationTime} value={state.messageExpirationTime.toString(10)} onChange={this.handleChange}>
                                                {state.messageExpirationTimes.map((messageExpirationTime) =>
                                                    <option key={messageExpirationTime.number} value={messageExpirationTime.number.toString(10)}>{messageExpirationTime.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.Description}</label>
                                            <textarea className="form-control large" name="comment" title={Translations.Description} maxLength={500} value={state.comment} required={true} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {state.page === NewInstantMessageChannelDialogPage.Users &&
                            <div>
                                <InstantMessageChannelUserList
                                    isReadOnly={false}
                                    newChannelWizard={true}
                                    companies={state.channelType === NewInstantMessageChannelType.External ? item.companies : [item.companies[0]]}
                                    user={props.user}
                                    instantMessageChannelId={state.id}
                                    instantMessageChannelCompanyId={state.companyId}
                                    users={state.channelUsers}
                                    onRemoved={this.handleUsersRemoved}
                                    onAdded={this.handleUsersAdded}
                                    onUserTypeUpdated={null}
                                />
                            </div>
                        }
                        {state.page === NewInstantMessageChannelDialogPage.User &&
                            <div>
                                <SelectUserList
                                    companies={item.companies}
                                    loadUsers={this.handleLoadUsers}
                                    onSelect={this.handleUserSelect}
                                />
                            </div>
                        }
                    </div>
                }
                buttons={buttons}
                onClose={this.handleCancel}
            />
        );
    }
}